import { get } from '../../../../GlobalModules/Utility/Http'
import { mapBookings, mapCalendarEvents } from '../Model/CalendarModel'

// Fetch bookings & events list
export const getBookingsApi = async (filters = {}) => {
  const queryParams = {}

  const filtersObj = {
    limit: filters.limit || 10,
    offset: filters.offset || 0
  }

  // Add store_id filter if provided
  if (filters.store_id) {
    filtersObj.store_id = filters.store_id
  }

  if (filters.search && filters.search !== '') {
    queryParams.filter_op = JSON.stringify({ search_attr: 'substring' })
    filtersObj.search_attr = filters.search
  }

  // Add sorting if provided
  if (filters.sort && filters.sort.length > 0) {
    filtersObj.sort = [
      {
        field: filters.sort[0].field,
        sort: filters.sort[0].sort
      }
    ]
  } else {
    // Default sorting
    filtersObj.sort = [
      {
        field: 'id',
        sort: 'desc'
      }
    ]
  }

  queryParams.filters = JSON.stringify(filtersObj)

  const response = await get(`${process.env.EXTENDED_URL}booking`, queryParams)
  return mapBookings(response)
}

// Fetch calendar events between start and end dates
export const getCalendarEventsApi = async ({
  start_date,
  end_date,
  store_id
}) => {
  const queryParams = {
    start_date,
    end_date
  }

  // Add store_id if provided
  if (store_id) {
    queryParams.store_id = store_id
  }

  const response = await get(
    `${process.env.EXTENDED_URL}booking/calendar`,
    queryParams
  )
  return mapCalendarEvents(response)
}
